<template>
  <div>
    <div class="loading-block" v-if="!this.chartDone"></div>

    <ChartWithExport
      v-bind:chartId="chartDataId"
      v-bind:chartData="chartData"
      v-bind:chartOptions="chartOptions"
      v-on:generateExcel="generateExcel"
    />
  </div>
</template>

<script>
import ChartWithExport from '@/components/ChartWithExport.vue';
import Chart from 'chart.js/auto';
import { de } from 'date-fns/locale';
export default {
  name: 'VisualizeResearchData',
  components: {
    ChartWithExport,
  },
  emits: ['generateExcel'],
  props: {
    dataForVisualize: {
      type: Object,
      required: true,
    },
  },
  watch: {
    dataForVisualize: {
      deep: true,
      handler() {
        this.prepareDataforChart();
      },
    },
  },
  data() {
    return {
      chartDone: true,
      chartDataset: [],
      chartDataId: 'test',
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            type: 'time',
            distribution: 'linear',
            time: {
              //unit: 'minute',
              tooltipFormat: 'dd.MM HH:mm',
              displayFormats: {
                millisecond: 'dd.MM HH:mm',
                second: 'dd.MM HH:mm',
                minute: 'dd.MM HH:mm',
                hour: 'dd.MM HH:mm',
                day: 'dd.MM HH:mm',
                week: 'dd.MM HH:mm',
                month: 'dd.MM HH:mm',
                quarter: 'dd.MM HH:mm',
                year: 'dd.MM HH:mm',
              },
            },
            adapters: {
              date: {
                locale: de,
              },
            },
          },
        },
        plugins: {
          zoom: {
            pan: {
              enabled: true,
              mode: 'x',
            },
            zoom: {
              pinch: {
                enabled: true,
              },
              wheel: {
                enabled: false,
              },
              drag: {
                enabled: false,
              },
              mode: 'x',
            },
            limits: {
              x: { min: 'original', max: 'original' },
            },
          },
          legend: {
            position: 'top',
          },
          notifyAfterRender: {
            doAfterRender: () => {
              this.chartDone = true;
            },
          },
        },
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      const canvas = this.$el.querySelector('canvas');
      if (!canvas) return;
      let lastTap = 0;
      canvas.addEventListener(
        'touchend',
        (e) => {
          const now = Date.now();
          if (now - lastTap < 300) {
            const chartInstance = Chart.getChart(canvas);
            if (chartInstance) {
              chartInstance.resetZoom();
            }
            e.preventDefault();
          }
          lastTap = now;
        },
        { passive: false }
      );
    });
  },
  updated() {
    console.log('entry updated');

    console.log('exit updated');
  },
  methods: {
    prepareDataforChart() {
      console.log('entry prepareDataforChart');
      console.log(this.dataForVisualize);
      if (this.dataForVisualize.length === 0) {
        return {};
      }
      const valueMap = new Map();

      // Populate the map with the values from the original array
      for (const item of this.dataForVisualize.data_array) {
        const { date, type, value } = item;
        valueMap.set(`${date}-${type}`, value);
      }

      // Get a list of all the distinct dates and types
      const dates = Array.from(new Set(this.dataForVisualize.data_array.map((item) => item.date)));
      const types = Array.from(new Set(this.dataForVisualize.data_array.map((item) => item.type)));
      const new_data_array = [];
      for (const date of dates) {
        for (const type of types) {
          // Look up the value in the map using the date and type as the key
          const value = valueMap.get(`${date}-${type}`) || null;
          new_data_array.push({ date, type, value });
        }
      }
      console.log(new_data_array);
      const chart_dataset_array = this.dataForVisualize.dataset_array.map((dataset) => {
        return {
          label: dataset.label,
          backgroundColor: dataset.backgroundColor,
          borderColor: dataset.borderColor,
          data: new_data_array.reduce((acc, data) => {
            if (data.type == dataset.type) {
              acc.push({ x: data.date, y: data.value });
            }
            return acc;
          }, []),
        };
      });
      console.log(chart_dataset_array);
      this.chartDataset = chart_dataset_array;
      this.chartDone = false;
      console.log('exit prepareDataforChart');
    },
    generateExcel() {
      console.log('entry generateExcel');
      this.$emit('generateExcel');
      console.log('exit generateExcel');
    },
  },
  computed: {
    chartData() {
      if (this.chartDataset === []) {
        return {};
      }

      console.log('this.chartDataset');
      console.log(this.chartDataset);
      return {
        datasets: this.chartDataset,
      };
    },
  },
};
</script>
